<template>
  <div>
    <v-dialog scrollable v-model="deleteDialog" persistent max-width="400">
      <material-card
        v-if="deletedItem"
        :title="
          selectedPlan.PlanType === 'Pension'
            ? $t('components.inmemorydependants.delete_spouse_{0}', [
                deletedItem.Name,
              ])
            : $t('components.inmemorydependants.delete_dependant_{0}', [
                deletedItem.Name,
              ])
        "
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="deleteDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="tryDelete">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="editDialog" persistent max-width="1000px">
      <material-card
        :title="formTitle"
        :color="formColor"
        :icon="formIcon"
        v-if="selectedPlan != null"
      >
        <v-card-text>
          <v-row>
            <v-container>
              <v-row>
                <v-col>
                  <v-form ref="dependantForm" v-model="valid">
                    <v-container fluid>
                      <v-row
                        v-if="
                          this.editedItem !== null &&
                            this.editedItem !== undefined
                        "
                      >
                        <v-col xs="12" sm="6" md="4" lg="4" v-if="selectedPlan.PlanType === 'Pension'">
                          <no-autocomplete-textfield
                            :disabled="planIdentity.AutogenerateCertificate"
                            :label="
                              $t(
                                'headers.in_memory_dependants.pension_spouse_id'
                              )
                            "
                            v-model="editedItem.PensionSpouseId"
                            :rules="[$rules.pensionSpouseId, $rules.required]"
                            class="required"
                          ></no-autocomplete-textfield>
                        </v-col>
                        <v-col xs="12" sm="6" md="4" lg="4">
                          <trans-select
                            :value.sync="editedItem.Relationship"
                            :items="relationships"
                            :label="
                              $t('components.inmemorydependants.relationship')
                            "
                            :rules="[$rules.required]"
                            class="required"
                          ></trans-select>
                        </v-col>
                        <v-col xs="12" sm="6" md="4" lg="4">
                          <no-autocomplete-textfield
                            :label="$t('headers.members_management.SIN')"
                            v-model="editedItem.SIN"
                            :rules="[$rules.sin]"
                          ></no-autocomplete-textfield>
                        </v-col>
                        <v-col xs="12" sm="6" md="4" lg="4">
                          <trans-select
                            :clearable="true"
                            :value.sync="editedItem.Title"
                            :items="columnsDropDownOptions.Models.Title"
                            :label="$t('headers.members_management.Title')"
                          ></trans-select>
                        </v-col>
                        <v-col xs="12" sm="6" md="4" lg="4">
                          <no-autocomplete-textfield
                            v-model="editedItem.FirstName"
                            :label="
                              $t('globals.firstname')
                            "
                            :rules="[$rules.required, $rules.validName]"
                            class="required"
                          ></no-autocomplete-textfield>
                        </v-col>
                        <v-col xs="12" sm="6" md="4" lg="4">
                          <no-autocomplete-textfield
                            v-model="editedItem.MiddleName"
                            :label="
                              $t('globals.middlename')
                            "
                            :rules="[$rules.validMiddleName]"
                          ></no-autocomplete-textfield>
                        </v-col>
                        <v-col xs="12" sm="6" md="4" lg="4">
                          <no-autocomplete-textfield
                            v-model="editedItem.LastName"
                            :label="
                              $t('globals.lastname')
                            "
                            :rules="[$rules.required, $rules.validLastName]"
                            class="required"
                          ></no-autocomplete-textfield>
                        </v-col>
                        <v-col xs="12" sm="6" md="4" lg="4">
                          <pbas-date-picker
                            :label="$t('globals.dob')"
                            :value="editedItem.DateOfBirth"
                            @update-date="editedItem.DateOfBirth = $event"
                            :allowedDates="dateOfBirthDates"
                            :rules="[$rules.required, $rules.dateOfBirth]"
                            class="required"
                          ></pbas-date-picker>
                        </v-col>
                        <v-col xs="12" sm="6" md="4" lg="4">
                          <trans-select
                            :clearable="true"
                            :item="editedItem"
                            propertyName="Suffix"
                            :items="columnsDropDownOptions.Models.Suffix"
                            :label="$t('headers.members_management.Suffix')"
                          ></trans-select>
                        </v-col>
                        <v-col xs="12" sm="6" md="4" lg="4">
                          <pbas-date-picker
                            clearable
                            :label="$t('components.inmemorydependants.dod')"
                            :value="editedItem.DateOfDeath"
                            @update-date="editedItem.DateOfDeath = $event"
                            :allowedDates="dateOfBirthDates"
                            :rules="[$rules.dateOfBirth]"
                          ></pbas-date-picker>
                        </v-col>
                        <v-col xs="12" sm="6" md="4" lg="4">
                          <trans-select
                            :value.sync="editedItem.Gender"
                            :items="genders"
                            :label="$t('globals.gender')"
                            :rules="[$rules.required]"
                            class="required"
                          ></trans-select>
                        </v-col>
                        <v-col
                          xs="12"
                          sm="6"
                          md="4"
                          lg="4"
                          v-if="
                            editedItem &&
                              editedItem.Relationship &&
                              editedItem.Relationship.IsChild &&
                              !editedItem.Relationship.IsSpouse
                          "
                        >
                          <v-checkbox
                            v-model="editedItem.Disabled"
                            :label="
                              $t('components.inmemorydependants.disabled')
                            "
                          ></v-checkbox>
                        </v-col>
                        <v-col
                          xs="12"
                          sm="6"
                          md="4"
                          lg="4"
                          v-if="editedItem && editedItem.Disabled"
                        >
                          <pbas-date-picker
                            clearable
                            :label="
                              $t(
                                'components.inmemorydependants.disability_approval_date'
                              )
                            "
                            :value="
                              editedItem.Identity.Qualification
                                .DisabilityApprovalDate
                            "
                            @update-date="
                              editedItem.Identity.Qualification.DisabilityApprovalDate = $event
                            "
                          ></pbas-date-picker>
                        </v-col>
                        <v-col
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          v-if="
                            useDocumentsManagement &&
                            editedItem && editedItem.Disabled
                          "
                        >
                          <multi-file-upload2
                            id="disabilityId"
                            @emit-upload-end="saving = false"
                            :files="files"
                            @emit-upload-start="saving = true"
                            :label="
                              $t(
                                'components.inmemorydependants.Proof Of Disability'
                              )
                            "
                            :tags="[selectedPlan.UniqueIdentifier]"
                            :categories="['DependantDisabilityProof']"
                            :currentFolder="selectedPlan.Name"
                            :zipDownloadUrl="
                              settings.DOCUMENTSERVICEURL +
                                'api/ZipFilesDownload'
                            "
                            :fileUploadUrl="
                              settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                            "
                            @emit-files="
                              bindProofOfDisability($event);
                              saving = false;
                            "
                            @emit-upload-error="
                              error = $event;
                              saving = false;
                            "
                          />
                        </v-col>
                        <v-col
                          v-if="
                            editedItem &&
                              editedItem.Relationship &&
                              editedItem.Relationship.IsChild
                          "
                          xs="12"
                          sm="6"
                          md="4"
                          lg="4"
                        >
                          <v-checkbox
                            :value="editedItem.Student"
                            :label="$t('components.inmemorydependants.student')"
                            @change="studentChanged($event)"
                          ></v-checkbox>
                        </v-col>
                        <v-col
                          xs="12"
                          sm="6"
                          md="4"
                          lg="4"
                          v-if="showSchoolDate"
                        >
                          <pbas-date-picker
                            clearable
                            :label="
                              $t(
                                'components.inmemorydependants.school_completion_date'
                              )
                            "
                            :value="
                              editedItem.Identity.Qualification
                                .SchoolCompletionDate
                            "
                            @update-date="
                              editedItem.Identity.Qualification.SchoolCompletionDate = $event
                            "
                          ></pbas-date-picker>
                        </v-col>
                        <v-col
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          v-if="
                            useDocumentsManagement &&
                            editedItem && editedItem.Student
                          "
                        >
                          <multi-file-upload2
                            id="schoolId"
                            @emit-upload-end="saving = false"
                            :files="files"
                            @emit-upload-start="saving = true"
                            :label="
                              $t(
                                'components.inmemorydependants.Proof Of Schooling'
                              )
                            "
                            :tags="[selectedPlan.UniqueIdentifier]"
                            :categories="['DependantSchoolingProof']"
                            :currentFolder="selectedPlan.Name"
                            :zipDownloadUrl="
                              settings.DOCUMENTSERVICEURL +
                                'api/ZipFilesDownload'
                            "
                            :fileUploadUrl="
                              settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                            "
                            @emit-files="
                              bindProofOfSchooling($event);
                              saving = false;
                            "
                            @emit-upload-error="
                              error = $event;
                              saving = false;
                            "
                          />
                        </v-col>
                        <v-col
                          xs="12"
                          sm="6"
                          md="4"
                          lg="4"
                          v-if="
                            editedItem &&
                              editedItem.Relationship &&
                              editedItem.Relationship.IsSpouse
                          "
                        >
                          <pbas-date-picker
                            clearable
                            :label="
                              $t(
                                'components.inmemorydependants.date_of_mariage'
                              )
                            "
                            :value="
                              editedItem.Identity.Qualification.DateOfMarriage
                            "
                            @update-date="
                              editedItem.Identity.Qualification.DateOfMarriage = $event
                            "
                          ></pbas-date-picker>
                        </v-col>
                        <v-col
                          xs="12"
                          sm="6"
                          md="4"
                          lg="4"
                          v-if="
                            editedItem &&
                              editedItem.Relationship &&
                              editedItem.Relationship.IsSpouse
                          "
                        >
                          <v-checkbox
                            v-model="editedItem.IsSmoker"
                            :label="$t('components.inmemorydependants.smoker')"
                          ></v-checkbox>
                        </v-col>
                        <v-col
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          v-if="
                            useDocumentsManagement &&
                            editedItem &&
                              editedItem.Relationship &&
                              editedItem.Relationship.IsSpouse
                          "
                        >
                          <multi-file-upload2
                            id="lawId"
                            @emit-upload-end="saving = false"
                            :files="files"
                            @emit-upload-start="saving = true"
                            :label="
                              $t(
                                'components.inmemorydependants.Proof Of Common Law Status'
                              )
                            "
                            :tags="[selectedPlan.UniqueIdentifier]"
                            :categories="['DependantCommonLawStatusProof']"
                            :currentFolder="selectedPlan.Name"
                            :zipDownloadUrl="
                              settings.DOCUMENTSERVICEURL +
                                'api/ZipFilesDownload'
                            "
                            :fileUploadUrl="
                              settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                            "
                            @emit-files="
                              bindProofOfCommonLawStatus($event);
                              saving = false;
                            "
                            @emit-upload-error="
                              error = $event;
                              saving = false;
                            "
                          />
                        </v-col>
                        <v-col
                          xs="12"
                          sm="6"
                          md="4"
                          lg="4"
                          v-if="
                            selectedPlan.PlanType === 'Pension' &&
                              editedItem &&
                              editedItem.Relationship &&
                              editedItem.Relationship.IsSpouse
                          "
                        >
                          <pbas-date-picker
                            clearable
                            :label="
                              $t(
                                'components.inmemorydependants.spousal_waiver_signal_date'
                              )
                            "
                            :value="
                              editedItem.Identity.Qualification
                                .SpousalWaiverDate
                            "
                            @update-date="updateSpousalWaiverDate($event)"
                            :allowedDates="dateOfBirthDates"
                            :rules="[$rules.dateOfBirth]"
                          ></pbas-date-picker>
                        </v-col>
                        <v-col
                          xs="12"
                          sm="12"
                          md="12"
                          lg="12"
                          v-if="
                          useDocumentsManagement &&
                            editedItem &&
                              editedItem.Identity &&
                              editedItem.Identity.Qualification
                                .SpousalWaiverDate !== null &&
                              editedItem.Identity.Qualification
                                .SpousalWaiverDate !== undefined
                          "
                        >
                          <multi-file-upload2
                            id="spousalWaiverId"
                            @emit-upload-end="saving = false"
                            :files="files"
                            @emit-upload-start="saving = true"
                            :label="
                              $t('components.inmemorydependants.spousal_waiver')
                            "
                            :tags="[selectedPlan.UniqueIdentifier]"
                            :categories="['DependantSpousalWaiver']"
                            :currentFolder="selectedPlan.Name"
                            :zipDownloadUrl="
                              settings.DOCUMENTSERVICEURL +
                                'api/ZipFilesDownload'
                            "
                            :fileUploadUrl="
                              settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                            "
                            @emit-files="
                              bindSpousalWaiver($event);
                              saving = false;
                            "
                            @emit-upload-error="
                              error = $event;
                              saving = false;
                            "
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="saving" text @click="close">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid"
            :loading="saving"
            color="primary"
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <material-card
      :title="
        selectedPlan.PlanType === 'Pension'
          ? $t('components.memberwizard.spousal_information')
          : $t('globals.dependants')
      "
      :color="$vuetify.theme.themes.light.secondary"
      icon="family_restroom"
    >
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="floatActions"
        fileNamePrefix="dependants"
        @itemsChanged="setData($event)"
        :identifier="identifier"
        @error="error = $event"
      ></pbas-data-table>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { InMemoryProvider } from "pbas-vue-components";
import ErrorHandler from "../components/ErrorHandler";
import getInMemoryDependantsHeaders from "../headers/InMemoryDependants";
import TransSelect from "@/components/controls/TransSelect";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { createMemberFile } from "../makeMemberFile";
import MultiFileUpload2 from "../components/MultiFileUpload2.vue";
import SettingsService from "@/services/settings.service.js";

export default {
  name: "in-memory-dependants",
  components: {
    ErrorHandler,
    TransSelect,
    NoAutocompleteTextfield,
    MultiFileUpload2,
  },
  props: [
    "dependants",
    "identifier",
    "memberId",
    "maritalStatus",
    "planName",
    "planId",
    "files",
  ],
  data() {
    return {
      selectedRelationship: null,
      showSchoolDate: false,
      deletedItem: null,
      deleteValid: true,
      effectiveDate: null,
      error: null,
      valid: true,
      items: [],
      deleteDialog: false,
      provider: undefined,
      saving: false,
      genders: [],
      floatActions: [
        {
          name: "addItem",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: async () => {
            let dependant = {
              Identifier: Math.random(),
              Identity: {
                Qualification: {},
              },
            };
            if (this.planIdentity.AutogenerateCertificate) {
              if (this.selectedPlan.PlanType === "Pension") {
                dependant.PensionSpouseId = (await this.getNewCertificate({
                  planIdentityId: this.selectedPlan.Id,
                  entity: "Spouse",
                })).data.value;
              }
            }
            this.editItem(dependant);
          },
        },
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.editItem(item),
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            let o;
            if (item.Id) {
              o = this.items.filter((o) => o.Id === item.Id)[0];
            } else {
              o = this.items.filter((o) => o.Identifier === item.Identifier)[0];
            }
            this.editedIndex = this.provider.items.indexOf(o);
            this.deletedItem = item;
            this.deleteDialog = true;
          },
        },
      ],
      e6: 1,
      editDialog: false,
      headers: [],
      editedIndex: -1,
      editedItem: null,
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", {
      columnsDropDownOptions: "options",
      planParameters: "planOptions",
    }),
    ...mapGetters("plansMembers", ["planIdentity"]),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["settings"]),
    useDocumentsManagement() {
      var settings = SettingsService.settings;
      // console.log("useDocumentsManagement", settings.UseDocumentsManagement);
      return settings.UseDocumentsManagement;
    },
    formIcon() {
      return this.editedIndex === -1 ? "add" : "edit";
    },
    formColor() {
      return this.editedIndex === -1 ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
    formTitle() {
      if (this.selectedPlan.PlanType === "Pension") {
        return this.editedIndex > -1
          ? this.$t("components.inmemorydependants.edit_spouse_{0}", [
              this.editedItem.Name,
            ])
          : this.$t("components.inmemorydependants.create_new_spouse");
      }
      return this.editedIndex > -1
        ? this.$t("components.inmemorydependants.edit_dependant_{0}", [
            this.editedItem.Name,
          ])
        : this.$t("components.inmemorydependants.create_new_dependant");
    },
    relationships() {
      if (this.selectedPlan.PlanType === "Pension") {
        return this.columnsDropDownOptions.Models.Relationship.filter(
          (o) => o.IsSpouse
        );
      } else {
        if (this.maritalStatus && this.maritalStatus.AllowSpouse === false) {
          return this.columnsDropDownOptions.Models.Relationship.filter(
            (o) => !o.IsSpouse
          );
        } /*else if (this.maritalStatus.AllowChild === false) {
        return this.columnsDropDownOptions.Models.Relationship.filter(o=>!o.IsChild);
      }*/
        return this.columnsDropDownOptions.Models.Relationship;
      }
    },
  },
  watch: {
    dependants: {
      immediate: true,
      handler(v) {
        if (v) {
          if (this.provider) {
            this.provider.items = v;
            this.$refs.table.getDataAsync();
          }
        }
      },
      deep: true,
    },
    "editedItem.Relationship": {
      handler(v) {
        console.log("relationship: ", v);
        if (v !== null && v !== undefined) {
          if (!v.IsChild) {
            this.editedItem.Student = false;
            this.showSchoolDate = false;
            delete this.editedItem.Identity.Qualification.SchoolCompletionDate;
          }
          if (!v.IsChild || v.IsSpouse) {
            this.editedItem.Disabled = false;
          }
          if (!v.IsSpouse) {
            delete this.editedItem.Identity.Qualification.DateOfMarriage;
            this.editedItem.IsSmoker = false;
          }
          if (this.selectedRelationship !== this.editedItem.Relationship) {
            this.selectedRelationship = this.editedItem.Relationship;
            // if (this.planIdentity.UseDocumentManagement) {
            this.resetBinds();
            // }
            console.log(this.editedItem);
          }
        }
      },
    },
    // "editedItem.Student": {
    //   handler(v) {
    //     console.log("student: ", v);
    //     if (v===false && this.editedItem !==null && this.editedItem !== undefined) {
    //       console.log("student: ", v);
    //       this.editedItem.Identity.Qualification.SchoolCompletionDate = null;
    //       console.log(JSON.stringify(this.editedItem));
    //     }
    //   },
    // },
    "editedItem.Disabled": {
      handler(v) {
        if (
          v === false &&
          this.editedItem !== null &&
          this.editedItem !== undefined
        ) {
          delete this.editedItem.Identity.Qualification.DisabilityApprovalDate;
        }
      },
    },
  },
  mounted() {
    this.loadPlanData();
  },
  methods: {
    ...mapActions("plansMembers", ["getNewCertificate",]),
    studentChanged(val) {
      console.log("student changed: ", val);
      this.editedItem.Student = val;
      this.showSchoolDate = val;
      if (!val) {
        delete this.editedItem.Identity.Qualification.SchoolCompletionDate;
      }
      console.log(this.editedItem.Identity.Qualification.SchoolCompletionDate);
    },
    dateOfBirthDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      const d2 = new Date();
      return d <= d2;
    },
    bindProofOfSchooling(memberFile) {
      this.editedItem.Identity.Qualification.ProofOfSchooling = createMemberFile(
        memberFile,
        "DependantSchoolingProof",
        this.memberId
      );
    },
    bindProofOfDisability(memberFile) {
      this.editedItem.Identity.Qualification.ProofOfDisability = createMemberFile(
        memberFile,
        "DependantDisabilityProof",
        this.memberId
      );
    },
    bindProofOfCommonLawStatus(memberFile) {
      this.editedItem.Identity.Qualification.ProofOfCommonLawStatus = createMemberFile(
        memberFile,
        "DependantCommonLawStatusProof",
        this.memberId
      );
    },
    bindSpousalWaiver(memberFile) {
      this.editedItem.Identity.Qualification.SpousalWaiver = createMemberFile(
        memberFile,
        "DependantSpousalWaiver",
        this.memberId
      );
    },
    resetBinds() {
      if (this.editedItem.Identity.Qualification.ProofOfSchooling) {
        delete this.editedItem.Identity.Qualification.ProofOfSchooling;
      }
      if (this.editedItem.Identity.Qualification.ProofOfDisability) {
        delete this.editedItem.Identity.Qualification.ProofOfDisability;
      }
      if (this.editedItem.Identity.Qualification.ProofOfCommonLawStatus) {
        delete this.editedItem.Identity.Qualification.ProofOfCommonLawStatus;
      }
      if (this.editedItem.Identity.Qualification.SpousalWaiver) {
        delete this.editedItem.Identity.Qualification.SpousalWaiver;
      }
    },
    reload() {
      this.$refs.table.getDataAsync();
    },
    setData(items) {
      this.items = items;
    },
    async loadPlanData() {
      try {
        this.genders = this.columnsDropDownOptions.Models.Gender;
        this.headers = getInMemoryDependantsHeaders(this.selectedPlan.PlanType);
        this.provider = new InMemoryProvider(this.dependants, this.headers);
      } catch (error) {
        this.error = error;
      }
    },
    async editItem(item) {
      let dep;
      if (item.Id) {
        dep = this.items.filter((o) => o.Id === item.Id)[0];
      } else {
        dep = this.items.filter((o) => o.Identifier === item.Identifier)[0];
      }
      if (item.Identity === null || item.Identity === undefined) {
        item.Identity = {
          Qualification: {},
        };
      }
      this.editedIndex = this.items.indexOf(dep);
      this.editedItem = JSON.parse(JSON.stringify(item));
      console.log(this.editedItem.Student);

      this.editDialog = true;
      this.$nextTick(() => {
        let c = this.$refs.studentCheckbox;
        console.log(c);
        this.student = this.editedItem.Student;
        console.log(this.student);
      });
    },
    close() {
      if (this.$refs.dependantForm) this.$refs.dependantForm.resetValidation();
      this.editDialog = false;
      this.editedItem = null;
      this.editedIndex = -1;
      this.effectiveDate = null;
    },
    save() {
      //this.editedItem.PlanIdentityId = this.selectedPlan.Id;
      //this.editedItem.MemberIdentityId = this.selectedPlan.Id;
      let item = JSON.parse(JSON.stringify(this.editedItem));
      if (!item.Relationship.IsChild) {
        item.Student = false;
      }
      // if (
      //   item.Identity &&
      //   Object.keys(item.Identity.Qualification).length === 0
      // ) {
      //   delete item.Identity;
      // }
      if (item.Relationship.IsSpouse) {
        if (this.otherSpouse()) {
          let error = new Error();
          error.customMessage = this.$t(
            "components.inmemorydependants.spouse_exists"
          );
          this.error = error;
          return;
        }
        if (!item.IsSmoker) {
          item.IsSmoker = false;
        }
      } else {
        item.IsSmoker = false;
      }
      if (this.editedIndex > -1) {
        this.update(item);
      } else {
        this.add(item);
      }
    },
    async update(item) {
      this.close();
      this.$emit("changed-updated", item);
    },
    async add(item) {
      this.close();
      this.$emit("changed-added", item);
    },
    async tryDelete() {
      let item = JSON.parse(JSON.stringify(this.deletedItem));
      item.IsRemoved = true;
      this.deleteDialog = false;
      this.$emit("changed-removed", item);
    },
    otherSpouse() {
      const spouse = this.dependants.filter((o) => o.Relationship.IsSpouse);
      if (spouse.length === 0) {
        return false;
      }
      if (this.editedIndex === -1) {
        return true;
      }
      return this.dependants.indexOf(spouse[0]) !== this.editedIndex;
    },
    updateSpousalWaiverDate(date) {
      this.editedItem.Identity.Qualification.SpousalWaiverDate = date;
      this.$forceUpdate();
    },
  },
};
</script>
